import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { UsersState } from './users.state';

export namespace UsersSelectors {
  export const users = (state: AppState): UsersState => state.usersList;

  export function getUsers(): MemoizedSelector<
    AppState,
    UsersState,
    DefaultProjectorFn<UsersState>
  > {
    return createSelector(users, (state: UsersState) => state);
  }
}
